module.exports = __webpack_public_path__ + "static/media/Shyvana.87490f7a.png";